import { TournamentConditionTypeEnum } from 'config/types/tournament'
import { ColumnsDefTypes } from 'UIKit/Table/type'

export const TournamentFullLeaderBoardSchema: ColumnsDefTypes[] = [
  {
    id: 0,
    name: 'rank',
    label: 'Rank',
    width: '10%',
  },
  {
    id: 1,
    name: 'displayName',
    label: 'Player',
    width: '30%',
  },
  {
    id: 2,
    name: 'wagerAmount',
    label: 'Wager',
    width: '30%',
  },
  {
    id: 3,
    name: 'multiplier',
    label: 'Multiplier',
    width: '30%',
  },
  {
    id: 4,
    name: 'prize',
    label: 'Prize',
    width: '30%',
  },
]

export const TournamentCompactLeaderBoardSchema: ColumnsDefTypes[] = [
  {
    id: 0,
    name: 'rank',
    label: 'Rank',
    width: '10%',
  },
  {
    id: 1,
    name: 'userInfo',
    label: 'Player, Wager',
    width: '40%',
  },

  {
    id: 2,
    name: 'prize',
    label: 'Prize',
    width: '50%',
  },
]

export const renderCompactLeaderBoardHeader = (conditionType: TournamentConditionTypeEnum) => {
  return [
    {
      id: 0,
      name: 'rank',
      label: 'Rank',
      width: '20%',
    },
    {
      id: 1,
      name: 'userInfo',
      label: `Player, ${conditionType === TournamentConditionTypeEnum.Wager ? 'Wager' : 'Multiplier'}`,
      width: '50%',
    },

    {
      id: 2,
      name: 'prize',
      label: 'Prize',
      width: '50%',
    },
  ]
}

export const PROVIDER_PREFIX_ID = 'pr-'
